import { createAction, props } from '@ngrx/store';

export enum AppendixesActions {
  AppendixesRequested = '[Appendixes] Appendixes Requested',
  AppendixesLoaded = '[Appendixes] Appendixes Loaded',
  AppendixesError = '[Appendixes] Appendixes Error',
  AppendixTypesRequested = '[Appendixes] Appendix Types Requested',
  AppendixTypesLoaded = '[Appendixes] Appendix Types Loaded',
  AppendixTypesError = '[Appendixes] Appendix Types Error'
}

export const AppendixesRequested = createAction(AppendixesActions.AppendixesRequested);
export const AppendixTypesRequested = createAction(AppendixesActions.AppendixTypesRequested);

export const AppendixesLoaded = createAction(AppendixesActions.AppendixesLoaded,
  props<{ appendixes: any[] }>());

export const AppendixTypesLoaded = createAction(AppendixesActions.AppendixTypesLoaded,
  props<{ appendixTypes: any[] }>());  

export const AppendixesError = createAction(AppendixesActions.AppendixesError);
export const AppendixTypesError = createAction(AppendixesActions.AppendixTypesError);